import React from 'react'
import injectStyles from 'react-jss'
import { useDispatch } from 'react-redux'
import { PATHS } from '../../../Config/Routing/paths'
import { styles } from './styles'
import { getNextLink } from '../../../Utils/Link'
import { PageTitle } from 'Components/PageTitle'
import CredentialsTable from './components/CredentialsTable'
import { useState } from 'react'
import {
  createAPIKey,
  fetchUsersAPIKeys,
  updateAPIKey,
} from '../../../Module/ConversionAPI/client'
import { useEffect } from 'react'
import { showReduxModal, hideReduxModal } from '../../../Reducers/UI/actions'
import RevokeModal from './components/RevokeModal'
import { KEY_STATUS, TOKEN_TYPE } from './const'
import { authorization } from '../../../Module/Auth/Auth'
import ArrowBackIcon from '../../ClientSettings/icons/ArrowBackIcon'
import usePosthogAnalyticsIntegrations from '../hooks/usePosthogAnalyiticsIntegrations'

/* KEYS DATA EXAMPLE 
  [{
    clientId: "450"
    createdAt: "2023-10-04T09:02:25.550Z"
    id: "eab0e71a-5cbc-4936-baa1-9f115ff5a964"
    key: "ngnfnjfgjnfgnjfnjgnfjgnjfngjfjngnjfgnjfgnjngjf"
    lastUsedAt: null
    status: 0
    type: "PRIVATE"
    updatedAt: "2023-10-04T09:02:32.246Z" 
  }]
*/
const APIIntegration = ({ classes }) => {
  const [keys, setKeys] = useState(null)
  const dispatch = useDispatch()
  const { client } = authorization.getUser()
  const getKeys = async () => {
    const usersAPIKeys = await fetchUsersAPIKeys()
    // Filter out keys managed by IntegrationConnection table in db
    const filteredKeys = usersAPIKeys.filter(
      key => key.integrationId === null || key.integrationId === undefined,
    )
    const formattedData = filteredKeys.map(key => ({
      name: 'Secret key',
      ...key,
    }))
    const sortedByCreatedAt = formattedData.sort(
      (a, b) => new Date(a.createdAt) - new Date(b.createdAt),
    )
    setKeys(sortedByCreatedAt)
  }
  const { emitAnalyticsEvent } = usePosthogAnalyticsIntegrations()

  useEffect(() => {
    getKeys()
  }, [])

  const onCreateKey = async () => {
    emitAnalyticsEvent('Token Action', {
      type: 'web_api',
      action_type: 'create',
    })
    await createAPIKey(TOKEN_TYPE.PUBLIC)
    await getKeys()
  }

  const onRevokeKey = async id => {
    emitAnalyticsEvent('Token Action', {
      type: 'web_api',
      action_type: 'revoke',
    })
    await updateAPIKey(id, KEY_STATUS.INACTIVE)
    await getKeys()
    dispatch(hideReduxModal())
  }
  const onBack = () => {
    window.location.href = getNextLink(
      `${PATHS.main.dashboard}${client ? `/${client.id}` : ''}${
        PATHS.dashboard.integrations
      }`,
    )
  }

  const openRefuseModal = id => {
    return dispatch(
      showReduxModal({
        children: (
          <RevokeModal
            onOkay={async () => await onRevokeKey(id)}
            onClose={() => dispatch(hideReduxModal())}
          />
        ),
        hideConfirm: true,
        hideCancel: true,
        hideButtons: true,
      }),
    )
  }

  return (
    <div className={classes.APIwrapper}>
      <div className={classes.container}>
        <div className={classes.back} onClick={onBack}>
          <ArrowBackIcon height={12} width={16} color="#4F5B94" />
          Back to Integrations
        </div>
        <div>
          <PageTitle className={classes.title} cypress_id="pageTitle">
            API Integration
          </PageTitle>
          <div className={classes.description} cypress_id="apiIntDescription">
            You can utilise our secure API to programmatically send your
            campaigns' conversions. Each request will need to be authenticated
            with a valid access token.
            <br />
            <br />
            We strongly encourage you to treat access tokens as passwords and
            store them securely.
          </div>
        </div>
        <div className={classes.tableTitle}>Manage your keys:</div>
        <CredentialsTable
          data={keys}
          onCreate={onCreateKey}
          onRevoke={openRefuseModal}
          cypress_id="keysTable"
          addRowData={{
            name: 'Secret key',
            status: null,
          }}
        />
      </div>
      <div className={classes.footer}>
        You can access Promofy API documentation{' '}
        <a
          href="https://developer.oppizi.com/"
          className={classes.linkButton}
          target={'_blank'}
          cypress_id="apiDocumentation"
          onClick={() => {
            emitAnalyticsEvent('Clicked to access API doc')
          }}
          rel="noreferrer"
        >
          here.
        </a>
      </div>
    </div>
  )
}

export default injectStyles(styles)(APIIntegration)
